import * as ModelApiUtil from "../../util/model_util";

export const RECEIVE_ALL_MODELS = "RECEIVE_ALL_MODELS"
export const RECEIVE_MODEL = "RECEIVE_MODEL"
export const UPDATE_FILE_LIST = "UPDATE_FILE_LIST"
export const RECEIVE_FILE_LIST = "RECEIVE_FILE_LIST"
export const RECEIVE_REMOVED_FILE = "RECEIVE_REMOVED_FILE"
export  const RECEIVE_API_FILE_LIST = "RECEIVE_API_FILE_LIST"
const receiveAllModels = (models) => {
    return {
        type: RECEIVE_ALL_MODELS,
        models
    }
}

const receiveModel = (model) => {
    return {
        type: RECEIVE_MODEL,
        model
    }
}

const receiveAPIFileList = (payload) => {
    return {
        type: RECEIVE_API_FILE_LIST,
        fileList: payload
    }
}


const receiveRemovedFile = (index) => {
    return {
        type: RECEIVE_REMOVED_FILE,
        index: index
    }
}

const updateFileList = (file, index) => {
    return {
        type: UPDATE_FILE_LIST,
        file,
        index
    }
}

export const fetchAllModels = (signalToken) => dispatch => {
    return ModelApiUtil.fetchAllModels(signalToken)
        .then(models => dispatch(receiveAllModels(models)))
};

export const uploadModel = (modelPayload) => dispatch => {
    return ModelApiUtil.uploadModel(modelPayload)
      .then(model => dispatch(receiveModel(model.data)))
};
export const fetchFileListData = (cancelToken) => dispatch => {
    return ModelApiUtil.fetchFileListData(cancelToken)
    .then(fileList => {
        let payload = {}
        fileList.forEach((file, index) => {
            payload[index] = file
        })
        dispatch(receiveAPIFileList(payload))
    })
}


export const saveFileList = (file, index) => dispatch => {
    dispatch(updateFileList(file, index))
}

export const removeFileFromList = (index) => dispatch => {
        dispatch(receiveRemovedFile(index))
}

export const approveModel = (payload) => dispatch => {
    return ModelApiUtil.approveModel(payload)
    .then(model => {dispatch(receiveModel(model.data))})
}

export const removeModel = (id) => dispatch => {
    return ModelApiUtil.removeModel(id)
}